import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function SetParish({ c, onDone }: { c: any; onDone: () => void }) {
  const [charters, setCharters] = useState<any[]>([]);
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/dow/charters").then((r) => setCharters(r.data.filter((x: any) => !x.closed))).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/admin/cases/${c.id}/dow-parish`, { charter: pick });
      toast.success(`Parish set to ${data.location}. Click Send to Airtable to send it now.`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className={`mb-4 rounded-xl border p-4 ${c.airtable_held ? "border-[#FCD34D] bg-[#FFFBEB]" : "border-[#E2E8F0] bg-white"}`} data-testid="case-set-parish">
      {c.airtable_held && <p className="mb-2 flex items-center gap-2 text-sm font-semibold text-[#92400E]" data-testid="case-airtable-held"><AlertTriangle className="h-4 w-4" /> Held back from Airtable: no matching charter number. Choose the parish below.</p>}
      {!c.airtable_held && c.dow_match && <p className="mb-2 flex items-center gap-2 text-sm font-semibold text-[#92400E]" data-testid="case-dow-match-hint"><AlertTriangle className="h-4 w-4" /> This applicant looks like a Diocese parish ({c.dow_match}) but went to Airtable as {c.airtable_table}. Resend to Airtable moves it to the Diocese table, or pick the parish below.</p>}
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-semibold text-[#475569]">Set parish</span>
        <select className="field-input h-10 max-w-sm text-sm" value={pick} onChange={(e) => setPick(e.target.value)} data-testid="case-set-parish-select">
          <option value="">Choose a parish or school…</option>
          {charters.map((x) => <option key={x.charter} value={x.charter}>{x.charter} · {x.name}</option>)}
        </select>
        <button className="btn-primary btn-sm" disabled={!pick || busy} onClick={save} data-testid="case-set-parish-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save parish</button>
      </div>
    </div>
  );
}
